export enum TicketType {
  KWIFFED,
  SURPRISE_BET,
  CASHOUT,
}

export enum TicketFinalStatus {
  WIN = 1,
  LOST = 2,
  VOID = 3,
  CASHOUT = 10,
}

export enum TicketResult {
  WON = 1,
  LOST = 2,
  VOID = 3,
  CASHOUT = 4,
  PENDING = 5,
  PLACED = 6,
}

export enum SelectionResult {
  WON = 1,
  LOST = 2,
  VOID = 3,
  PENDING = 4,
  PLACED = 5,
}

export enum SystemBetBoostType {
  GOLD = 'gold',
  SILVER = 'silver',
  BRONZE = 'bronze',
}

export enum SystemBetPlacementStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export enum ENVELOPE_TYPE {
  ONE = 1,
  TWO = 2,
}
